import { Typography } from '@mui/material'
import React from 'react'

function Heading(props) {
    return (
        <Typography {...props}>What's in your fridge</Typography>
    )
}

export default Heading
